import { ArrowDownOutlined, ArrowUpOutlined, SearchOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import {isMobile} from 'react-device-detect';
import React from "react";
import _ from "underscore";
import { useDispatch } from "react-redux";
import SearchActions from "bukku/redux/Search/actions";
import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import BukkuTooltip from "bukku/components/Tooltip";

const { readTransactions } = SearchActions;

export default function Searchbar({
    // parent
    setSearchTerm,
    inputRef,
    focusedTab,
}) {
    useLingui();
    const dispatch = useDispatch();
    const handleSearchChange = searchTerm => {
        setSearchTerm(searchTerm);
        if (searchTerm)
            dispatch(readTransactions({ q: searchTerm }));
    };
    const handleSearchChangeDebounced = _.debounce(handleSearchChange, 200);

    return (
        <div className="isoSearchContainer">
            <Form.Item
                name="global_search_input"
                noStyle
            >
                <Input.Search
                    ref={inputRef}
                    // id="InputTopbarSearch"
                    size="large"
                    autoComplete="off"
                    placeholder={t`Search...`}
                    prefix={<SearchOutlined />}
                    suffix={
                        !isMobile && focusedTab === 'result' ?
                            <BukkuTooltip
                                // popupContainerId="parentElement"
                                // popupType="parent"
                                placement="bottomRight"
                                title={t`Use arrow keys to scroll up and down.`}
                            >
                                <kbd className="kbd-btn kbd-btn-xs"><ArrowUpOutlined /></kbd>
                                <kbd className="kbd-btn kbd-btn-xs"><ArrowDownOutlined /></kbd>
                            </BukkuTooltip>
                            : null
                    }
                    onChange={e => handleSearchChangeDebounced(e.target.value)}
                />
            </Form.Item>
        </div>
    );
}
